import React, { useCallback, useContext, useRef, useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LanguagesConfig from "./LanguagesConfig";
import { CustomizerContext } from "../context/CustomizerContext";
import { useDispatch, useSelector } from "react-redux";
import OverrideWithEnvironment from "./OverrideWithEnvironment";

const MENU_ITEM_HEIGHT = 48;

const OPTIONS = [
  {
    label: "Edit Data",
    key: "edit-data",
  },
  {
    label: "Language Settings",
    key: "lang-config",
  },
  {
    label: "Override with sandbox settings",
    key: "override-with-sandbox-settings",
  },
  {
    label: "Override with production settings",
    key: "override-with-production-settings",
  },
];

const TabOptions = () => {
  const { document } = useContext(CustomizerContext)
  const data = document && document.getMap("data");
  const currentData = useSelector((state) => state.selectedLanguageData);
  const dataTranslation = (currentData && currentData.startsWith("data-")) ? document.getMap(currentData) : false
  const [showMenu, setShowMenu] = useState(false);
  const [isLanguageConfigOpen, setIsLanguageConfigOpen] = useState(false);
  const [overrideEnvironment, setOverrideWithEnvironment] = useState(false);
  const menuAnchorRef = useRef(null);
  const dispatch = useDispatch()

  const handleToggleMenu = useCallback(() => {
    setShowMenu(!showMenu);
  }, [showMenu]);

  const handleToggleLanguageConfig = useCallback(() => {
    setIsLanguageConfigOpen(!isLanguageConfigOpen);
  }, [isLanguageConfigOpen]);

  const handleClose = useCallback(() => {
    setOverrideWithEnvironment(false);
  }, []);

  const handleOptionClick = useCallback((option) => {
    switch (option) {
      case "edit-data":
        dispatch({
          type: 'edit-json',
          data,
          dataTranslation
        })
        break;
      case "lang-config":
        handleToggleLanguageConfig();
        break;
      case "override-with-sandbox-settings":
        setOverrideWithEnvironment('sandbox');
        break;
      case "override-with-production-settings":
        setOverrideWithEnvironment('production');
        break;
      default:
    }
    handleToggleMenu();
  }, [handleToggleLanguageConfig, handleToggleMenu, dispatch, data, dataTranslation]);

  return (
    <>
      <LanguagesConfig
        isOpen={isLanguageConfigOpen}
        onClose={handleToggleLanguageConfig}
      />
      <OverrideWithEnvironment
        environment={overrideEnvironment}
        onClose={handleClose}
      />
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={showMenu ? "long-menu" : undefined}
        aria-expanded={showMenu ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleToggleMenu}
        ref={menuAnchorRef}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={menuAnchorRef?.current}
        open={showMenu}
        onClose={handleToggleMenu}
        PaperProps={{
          style: {
            maxHeight: MENU_ITEM_HEIGHT * 4.5,
            width: "31ch",
          },
        }}
      >
        {OPTIONS.map((option) => (
          <MenuItem
            key={option.key}
            onClick={() => handleOptionClick(option.key)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default TabOptions;
